import axios from "axios";

const BASE = process.env.REACT_APP_API_URL || "http://localhost:5001";

// POST /api/leave/add
export const applyLeaveApi = (data) =>
  axios.post(`${BASE}/api/leave/add`, data);

// POST /api/leave/admin-create  (super-admin marks leave for an employee)
export const adminCreateLeaveApi = (data) =>
  axios.post(`${BASE}/api/leave/admin-create`, data);

// PATCH /api/leave/admin-update/:id — correct an existing leave (any dates,
// back-dated included).
export const adminUpdateLeaveApi = (id, data) =>
  axios.patch(`${BASE}/api/leave/admin-update/${id}`, data);

// POST /api/leave/update  (admin — body: { id, active: "approved"|"rejected" })
export const updateLeaveStatusApi = (id, status) =>
  axios.post(`${BASE}/api/leave/update`, { id, active: status });

// DELETE /api/leave/delete/:id
export const deleteLeaveApi = (id) =>
  axios.delete(`${BASE}/api/leave/delete/${id}`);
